import { render } from "./AdsTab.vue?vue&type=template&id=00918e40&scoped=true"
import script from "./AdsTab.vue?vue&type=script&lang=js"
export * from "./AdsTab.vue?vue&type=script&lang=js"

import "./AdsTab.vue?vue&type=style&index=0&id=00918e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00918e40"]])

export default __exports__